var AWS = require('aws-sdk');
AWS.config.update({
    secretAccessKey: process.env.REACT_APP_S3_SECRET_KEY,
    accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY_ID,
    region: process.env.REACT_APP_S3_REGION
});

export default AWS